<template>
  <div class="useInfo-container app-container">
    <div class="useInfo-header bg-white">
      <!-- <div class="useInfo-header-top">
        <div>
          <p>机构数(个)</p>
          <p>3000</p>
        </div>
        <div>
          <p>设备数(个)</p>
          <p>3000</p>
        </div>
        <div>
          <p>用户数(人)</p>
          <p>13000</p>
        </div>
      </div> -->
      <div class="useInfo-header-bottom">
        <!-- <list-search @listSearchEvn="listSearchEvn" /> -->
        <div class="useInfo-header-bottom-date">
          <div class="booxCloud-date-select">
            <span
              v-for="item in dateType"
              :key="item.type"
              class="booxCloud-date-select-item"
              :class="{
                'booxCloud-date-select-active': type === item.type
              }"
              @click="changeType(item.type)"
              >{{ item.label }}</span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="useInfo-main" v-bar>
      <div>
        <PcLineChart v-if="pcStatsData" :chartData="pcStatsData" />
      </div>
    </div>
  </div>
</template>

<script>
import PcLineChart from './components/pcLineChart'
export default {
  components: {
    PcLineChart
  },
  data() {
    return {
      pcStatsData: null,
      type: 'day',
      params: {
        type: 'day'
      },
      dateType: [
        {
          type: 'day',
          label: '天'
        },
        {
          type: 'week',
          label: '周'
        },
        {
          type: 'month',
          label: '月'
        },
        {
          type: 'year',
          label: '年'
        }
      ]
    }
  },
  methods: {
    changeType(type) {
      if (this.type === type) return
      this.type = type
      this.params.type = type
      this.pcStatsByDate()
    },

    async pcStatsByDate() {
      try {
        let res = await this.$http.pcStatsByDate(this.params)
        this.pcStatsData = res.data
      } catch (error) {
        throw error
      }
    }
  },
  mounted() {
    this.pcStatsByDate()
  }
}
</script>

<style lang="scss">
.useInfo-container {
  .useInfo-header {
    padding: 10px 50px;
    .useInfo-header-top {
      display: flex;
      justify-content: space-around;
      padding: 20px 0 30px;
      border-bottom: 1px solid $globalBorderColor;
    }
    .useInfo-header-bottom {
      display: flex;
      justify-content: flex-end;
      margin-top: 20px;
      .useInfo-header-bottom-date {
        display: flex;
        align-items: center;
        .booxCloud-date-select {
          .booxCloud-date-select-item {
            display: inline-block;
            padding: 6px 12px;
            margin-left: 20px;
            font-size: 14px;
            border-radius: 4px;
            border: none;
            outline: none;
            cursor: pointer;
            -webkit-transition: all 0.3s;
            transition: all 0.3s;
            background: #ccc;
            color: #fff;
          }
          .booxCloud-date-select-active {
            background: #bf735b;
            color: #fff;
          }
        }
      }
    }
  }
  .booxCloud-date-select {
    .booxCloud-date-select-item {
      display: inline-block;
      padding: 6px 12px;
      margin-left: 20px;
      font-size: 14px;
      border-radius: 4px;
      border: none;
      outline: none;
      cursor: pointer;
      -webkit-transition: all 0.3s;
      transition: all 0.3s;
      background: #ccc;
      color: #fff;
    }
    .booxCloud-date-select-active {
      background: #bf735b;
      color: #fff;
    }
  }
  .useInfo-main {
    flex: 1;
    padding: 20px;
    overflow: hidden;
  }
}
</style>
